// extracted by mini-css-extract-plugin
export default {"container":"ArtikelList_container__Wp2pB","headercontainer":"ArtikelList_headercontainer__9fLMT"};